import { render, staticRenderFns } from "./settings-section-grid.vue?vue&type=template&id=8693affc&scoped=true&"
import script from "./settings-section-grid.vue?vue&type=script&lang=js&"
export * from "./settings-section-grid.vue?vue&type=script&lang=js&"
import style0 from "./settings-section-grid.vue?vue&type=style&index=0&id=8693affc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8693affc",
  null
  
)

export default component.exports